import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AboutView from '../views/AboutView.vue'
import PricingView from '../views/PricingView.vue'
import SupportView from '../views/SupportView.vue'
import HireIpad from '../views/HireIpad.vue'
import TermsVue from '../views/TermsVue.vue'
import PrivacyVue from '../views/PrivacyVue.vue'
import Registration from '../views/RegistrationForm.vue'
import LoginPage from '../views/LoginPage.vue'
import CookiesPolicies from '../views/CookiesPolicies.vue'
import ActivationUser from '../views/ActivationUser.vue'
import ChangePassword from '../views/ChangePassword.vue'

import FormChangePassword from '../views/FormChangePassword.vue'
import ResetPasswordForm from '../views/ResetPasswordForm.vue'

import FinishRegistration from '../views/finish/FinishRegistration.vue'
import FinishActivatioUser from '../views/finish/FinishActivatioUser.vue'
import FinishChangePassword from '../views/finish/FinishChangePassword.vue'
import FinishResetPassword from '../views/finish/FinishResetPassword.vue'
import FinishEditData from '../views/finish/FinishEditData.vue'
import RecoverPasswordFinish from '../views/finish/RecoverPasswordFinish.vue'
import NotFound from '../views/finish/NotFound.vue'
import ErrorPage from '../views/finish/ErrorPage.vue'

// Events

import EventsIndex from '../views/events/Index.vue'
import CreateEvent from '../views/events/CreateEvent.vue'
import CreateEventSecondStep from '../views/events/CreateEventSecondStep.vue'

import QrCodePage from '../views/events/QrCodePage.vue'

import CustomizeEvent from '../views/events/CustomizeEvent.vue'

// Emails
import EditorEmail from '../views/emails/EditorEmail.vue'
import ListEmail from '../views/emails/ListEmail.vue'

// Tavoli
import TableManager from '../views/tables/TableManager.vue'
import ListRooms from '../views/tables/ListRooms.vue'
import RoomCreateView from '../views/tables/RoomCreateView.vue'

// Billing
import Billing from '../views/billing/Billing.vue'
import CartView from '../views/billing/CartView.vue'

// Pax
import ImportGuests from '../views/guests/ImportGuests.vue'
import ListPax from '../views/guests/ListPax.vue'
import FormPax from '../views/guests/FormPax.vue'

import useAuthStore from '@/store/authStore.js'
import loadingStore from '@/store/loading'

import apiService from '@/services/apiService.js'
// import apiService from '@/services/apiService.js'
// import axios from 'axios'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView
  },
  {
    path: '/pricing',
    name: 'pricing',
    component: PricingView
  },
  {
    path: '/support',
    name: 'support',
    component: SupportView
  },
  {
    path: '/hire-ipad',
    name: 'hire-ipad',
    component: HireIpad
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: PrivacyVue
  },
  {
    path: '/terms',
    name: 'terms',
    component: TermsVue
  },

  {
    path: '/cookies-policies',
    name: 'cookies',
    component: CookiesPolicies
  },

  {
    path: '/registration',
    name: 'registration',
    component: Registration
  },

  {
    path: '/login',
    name: 'login',
    component: LoginPage
  },

  {
    path: '/user_active',
    name: 'activate',
    component: ActivationUser
  },

  {
    path: '/reset-password-form',
    name: 'resetform',
    component: ResetPasswordForm
  },

  {
    path: '/changepassword',
    name: 'changepassword',
    component: ChangePassword
  },

  {
    path: '/registration/finish',
    name: 'finishregistration',
    component: FinishRegistration
  },
  {
    path: '/user_active/finish',
    name: 'finishactivation',
    component: FinishActivatioUser
  },

  {
    path: '/changepassword/finish',
    name: 'finishchangepassword',
    component: FinishChangePassword
  },

  {
    path: '/modify/finish',
    name: 'finishmodify',
    component: FinishEditData
  },

  {
    path: '/recover-password',
    name: 'recoverpassword',
    component: FormChangePassword
  },

  {
    path: '/recover-password/finish',
    name: 'recoverpassword',
    component: RecoverPasswordFinish
  },

  {
    path: '/recover-password-email/finish',
    name: 'changepasswordemail',
    component: FinishResetPassword
  },

  {
    path: '/error',
    name: 'Error',
    component: ErrorPage
  },

  // Events

  {
    path: '/list-events',
    name: 'eventindex',
    component: EventsIndex,
    meta: { requiresAuth: true }
  },

  {
    path: '/new-event',
    name: 'createevent',
    component: CreateEvent,
    meta: { requiresAuth: true },
    props: { isNew: true }
  },

  {
    path: '/modify-event-back',
    name: 'modifyevent',
    component: CreateEvent,
    meta: { requiresAuth: true },
    props: { isNew: false, isBack: true }
  },

  {
    path: '/modify-event',
    name: 'modifyevent',
    component: CreateEvent,
    meta: { requiresAuth: true },
    props: { isNew: false }
  },

  {
    path: '/new-event-step2',
    name: 'createeventsecond',
    component: CreateEventSecondStep,
    meta: { requiresAuth: true },
    props: { isNew: true }
  },

  {
    path: '/new-event-step2-back',
    name: 'createeventsecond',
    component: CreateEventSecondStep,
    meta: { requiresAuth: true },
    props: { isNew: false, isBack: true }
  },

  {
    path: '/customize-label',
    name: 'customizelabels',
    component: CreateEventSecondStep,
    meta: { requiresAuth: true },
    props: { isNew: false }
  },

  {
    path: '/new-event-step3',
    name: 'customize',
    component: CustomizeEvent,
    meta: { requiresAuth: true },
    props: { isNew: true }
  },

  {
    path: '/new-event-step3-back',
    name: 'customize',
    component: CustomizeEvent,
    meta: { requiresAuth: true },
    props: { isNew: false, isBack: true }
  },

  {
    path: '/customize-event',
    name: 'customizeevent',
    component: CustomizeEvent,
    meta: { requiresAuth: true },
    props: { isNew: false }
  },

  {
    path: '/qrcode-events',
    name: 'qrcodeevents',
    component: QrCodePage,
    meta: { requiresAuth: true }
  },

  // fine events

  // pax
  {
    path: '/import-guests',
    name: 'importguests',
    component: ImportGuests,
    meta: { requiresAuth: true },
    props: { isNew: true }
  },

  {
    path: '/queuing-guests',
    name: 'importguests',
    component: ImportGuests,
    meta: { requiresAuth: true },
    props: { isNew: false }
  },

  {
    path: '/list-guests',
    name: 'listguests',
    component: ListPax,
    meta: { requiresAuth: true }
  },

  {
    path: '/form-guest',
    name: 'formguests',
    component: FormPax,
    meta: { requiresAuth: true },
    props: { isNew: true }
  },
  {
    path: '/edit-guest', // Per la modifica di un guest esistente (con UID come parametro)
    name: 'formguestsEdit',
    component: FormPax,
    meta: { requiresAuth: true },
    props: { isNew: false }

  },

  // Emails

  {
    path: '/list-email', // Per la modifica di un guest esistente (con UID come parametro)
    name: 'listmail',
    component: ListEmail,
    meta: { requiresAuth: true }

  },
  {
    path: '/edit-email', // Per la modifica di un guest esistente (con UID come parametro)
    name: 'editemail',
    component: EditorEmail,
    meta: { requiresAuth: true }

  },

  // fine pax

  // Tavoli

  {
    path: '/table-manager', // Per la modifica di un guest esistente (con UID come parametro)
    name: 'tablemanager',
    component: TableManager,
    meta: { requiresAuth: true }

  },

  {
    path: '/list-rooms', // Per la modifica di un guest esistente (con UID come parametro)
    name: 'listrooms',
    component: ListRooms,
    meta: { requiresAuth: true }

  },

  {
    path: '/create-room', // Per la modifica di un guest esistente (con UID come parametro)
    name: 'createroom',
    component: RoomCreateView,
    meta: { requiresAuth: true }

  },
  // Billing

  {
    path: '/billing', // Per la modifica di un guest esistente (con UID come parametro)
    name: 'billig',
    component: Billing,
    meta: { requiresAuth: true }

  },

  {
    path: '/cart', // Per la modifica di un guest esistente (con UID come parametro)
    name: 'cart',
    component: CartView,
    meta: { requiresAuth: true }

  },

  // fine tavoli

  {
    path: '*', // Corrisponde a qualsiasi percorso non definito
    name: 'NotFound',
    component: NotFound
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// --- Configurazione per l'estensione dei cookie ---
// const COOKIE_NAMES_TO_REFRESH = ['_pigoru', '_uigoru', 'rememberme'] // I nomi dei tuoi cookie di login
// const EXTEND_LIFETIME_SECONDS = 60 * 60; // Estendi di 1 ora (60 minuti * 60 secondi) - Variabile non utilizzata
// const CHECK_EXPIRATION_THRESHOLD_SECONDS = 5 * 60; // Se il cookie scade entro 5 minuti (in secondi), estendilo - Variabile non utilizzata
// const REFRESH_COOKIES_ENDPOINT = 'ajax/refresh_cookies.php' // Il tuo endpoint PHP
// const MIN_TIME_BETWEEN_SERVER_REFRESHES_MS = 30 * 1000 // Minimo 30 secondi tra una chiamata server e l'altra
// const lastServerRefreshTime = 0 // Timestamp dell'ultima chiamata al server per il refresh

// --- Navigation Guard per estendere i cookie ad ogni cambio di rotta ---
router.beforeEach((to, from, next) => {
  loadingStore.commit('setLoading', true)

  const isAuthenticated = useAuthStore.getters.isAuthenticated
  const requiresAuth = to.matched.some(route => route.meta.requiresAuth)
  const isLoginPage = to.name === 'login'

  // 🔐 accesso negato
  if (requiresAuth && !isAuthenticated) {
    apiService.logout()
    loadingStore.commit('setLoading', false)
    return next({
      name: 'login',
      query: { redirect: to.fullPath }
    })
  }

  // 🚫 login quando già autenticato
  if (isLoginPage && isAuthenticated) {
    loadingStore.commit('setLoading', false)
    return next({ name: 'eventindex' })
  }

  loadingStore.commit('setLoading', false)
  next()
})

export default router
